import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseApiService } from '../../../shared/base-service/base-api.service';
import { CustomerAccountTransactionSearchCriteria } from '../../models/customer-account-transaction-search-criteria.model';
import { CustomerAccountDetail } from '../../models/customer-account-detail.model';
import { CustomerAccountTransactionSearchCriteriaForReport } from '../../models/customer-account-transaction-search-for-report.model';

@Injectable()
export class CustomerAccountService extends BaseApiService {
    constructor() {
        super();
    }

    saveAccount(account: any) {
        return this.post('Customer/Account', account).pipe(catchError(this.handleError));
    }

    getNonCustomerManagedAccounts(customerNumberId: number) {
        return this.get('Customer/Account/CustomerNumber/' + customerNumberId + '/Accounts/NonManaged').pipe(catchError(this.handleError));
    }

    getCustomerAccounts(customerNumberId: number) {
        return this.get('Customer/Account/CustomerNumber/' + customerNumberId + '/Accounts').pipe(catchError(this.handleError));
    }

    getCustomerAccountDetails(customerAccountNumberId: number) {
        return this.get('Customer/Account/CustomerAccountNumber/' + customerAccountNumberId + '/AccountDetails').pipe(catchError(this.handleError));
    }

    getNumberOfAccounts(customerNumberId: number) {
        return this.get('Customer/Account/Count/CustomerNumber/' + customerNumberId).pipe(catchError(this.handleError));
    }

    saveAccountProperties(accountProperties: any) {
        return this.post('Customer/Account/properties', accountProperties).pipe(catchError(this.handleError));
    }

    saveAccountContact(accountContact: any) {
        return this.post('Customer/Account/Contact', accountContact).pipe(catchError(this.handleError));
    }

    saveAccountAddress(accountAddress: any) {
        return this.post('Customer/Account/Address', accountAddress).pipe(catchError(this.handleError));
    }

    saveAccountStatus(accountStatus: any) {
        return this.post('Customer/Account/Status', accountStatus).pipe(catchError(this.handleError));
    }

    getCustomerAccountNumber(customerAccountNumberId: number, customerAccountTypeId: number) {
        return this.get('Customer/Account/CustomerAccountNumber/' + customerAccountNumberId + '/AccountType/' + customerAccountTypeId + '').pipe(catchError(this.handleError));
    }

    public searchTransaction(
        customerAccountNumberId: number,
        criteria: CustomerAccountTransactionSearchCriteria
    ): Observable<any[]> {
        const url = 'Customer/Account/CustomerAccountNumber/' + customerAccountNumberId + '/Transaction/Search';
        return this.post(url, criteria).pipe(map(r => r.result));
    }

    public searchTransactionsForReport(
        criteria: CustomerAccountTransactionSearchCriteriaForReport
    ): Observable<any[]> {
        const url = 'Customer/Account/Transaction/Search/Report';
        return this.post(url, criteria).pipe(map(r => r.result));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            return observableThrowError(error.error);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }
}
